export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 9_03.522a6ff9.jpg";